import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Urls } from '@/lib/navigation';
import { trackDemoLaunched } from '@/analytics';
import { useOptionalVmClient } from '@/api/context';
import { useAppSession } from '@/contexts/SessionContext';

export const DemoActivatePage = () => {
  const { name } = useParams<{ name: string }>();
  const navigate = useNavigate();
  const vmClient = useOptionalVmClient();
  const { actions } = useAppSession();
  const activating = useRef(false);

  useEffect(() => {
    if (!vmClient || !name || activating.current) return;
    activating.current = true;
    trackDemoLaunched(name);

    let cancelled = false;
    vmClient
      .activateDemo(name)
      .then(async (sessionId) => {
        if (cancelled) return;
        await actions.handleSelectAgent(sessionId);
      })
      .catch(() => {
        if (!cancelled) navigate(Urls.demos(), { replace: true });
      });

    return () => { cancelled = true; activating.current = false; };
  }, [vmClient, name, navigate, actions]);

  return (
    <main className="flex flex-1 flex-col items-center justify-center gap-3">
      <Loader2 className="h-6 w-6 animate-spin text-zinc-400" />
      <p className="text-[13px] text-zinc-500">Launching demo&hellip;</p>
    </main>
  );
};
